import {Jurisdiction} from '@/utils/countries/constants'
import {Currency, DisabledCurrency} from '@/utils/currency'
import {BillingEntity, DiscountType} from '@/utils/pricing'

import {BillingEntityId} from './types'

export const includedCategoryClasses: Record<Jurisdiction, number> = {
  SK: 1,
  CZ: 1,
  UK: 1,
  US: 1,
  EU: 1,
  IE: 1,
  CH: 1,
  FR: 1,
  BX: 1,
  AU: 1,
  CA: 1,
  CN: 1,
  NZ: 1,
  JP: 1,
  TR: 1,
  SG: 1,
  HK: 1,
  DE: 1,
  BD: 1,
  IN: 1,
  BR: 1,
  MX: 1,
  NO: 1,
  ZA: 1,
  KR: 1,
  IT: 1,
  ES: 1,
  TH: 1,
  ID: 1,
  DK: 1,
  TW: 1,
  AR: 1,
  IL: 1,
  PL: 1,
  PT: 1,
  BG: 1,
  EE: 1,
  GE: 1,
  KZ: 1,
  LT: 1,
  LV: 1,
  RO: 1,
  UA: 1,
  VN: 1,
  SE: 1,
  FI: 1,
  HU: 1,
  AT: 1,
  SI: 1,
  HR: 1,
  CO: 1,
  EC: 1,
  PE: 1,
  MC: 1,
  AD: 1,
  EG: 1,
  JO: 1,
  KE: 1,
  LB: 1,
  MA: 1,
  NG: 1,
  PK: 1,
  TN: 1,
  TZ: 1,
  ME: 1,
  PY: 1,
  BO: 1,
  UY: 1,
  VE: 1,
  AM: 1,
  AZ: 1,
  KG: 1,
  MD: 1,
  TJ: 1,
  TM: 1,
  UZ: 1,
  DZ: 1,
  KH: 1,
  LA: 1,
  AO: 1,
  BI: 1,
  CV: 1,
  DJ: 1,
  CD: 1,
  ER: 1,
  ET: 1,
  GH: 1,
  MG: 1,
  MU: 1,
  OA: 1,
  AP: 1,
  AE: 1,
  CL: 1,
  MY: 1,
  PH: 1,
  SA: 1,
  KW: 1,
  OM: 1,
  QA: 1,
  BA: 1,
  BH: 1,
  PA: 1,
  IS: 1,
  CY: 1,
}

export const discountTypes: {[key in DiscountType]: DiscountType} = {
  absolute: 'absolute',
  percentage: 'percentage',
}

export const VAT_RATE = 23 as const

export const billingEntities: Record<BillingEntityId, BillingEntity> = {
  SK: {
    id: 'SK',
    name: 'Trama Legal s. r. o.',
    description: '',
    addressStreet: 'Bottova 2A',
    addressCity: '811 09 Bratislava',
    addressCountry: 'Slovenská republika',
    companyId: '54619556',
    companyTaxId: 'SK2121742645',
    currency: 'EUR',
    representative: 'JUDr. Igor Demčák',
    bankDetails: {
      EU: {
        accountHolder: 'Trama Legal s. r. o.',
        bic: 'REVOLT21',
        iban: 'LT74 3250 0701 7738 0160',
        bankAddress: 'Konstitucijos ave. 21B, 08130, Vilnius, Lithuania',
        bankName: 'Revolut Bank UAB',
      },
      GB: {
        accountHolder: 'Trama Legal s. r. o.',
        accountNumber: '83196099',
        sortCode: '04-00-75',
        iban: 'LT74 3250 0701 7738 0160',
        bankAddress: '7 Westferry Circus, E14 4HD, London, United Kingdom',
        bankName: 'Revolut Ltd',
      },
    },
    vatPayer: true,
    vatRate: VAT_RATE,
    registrationCountry: 'SK',
    invoiceIdPrefix: 'TM',
  },
}

export const defaultExchangeRate: Record<Currency | DisabledCurrency, number> = {
  EUR: 1,
  AUD: 1.56,
  CAD: 1.44,
  CZK: 25.57,
  GBP: 0.85,
  CHF: 1.06,
  NZD: 1.63,
  USD: 1.16,
  JPY: 130.48,
  TRY: 11.36,
  MXN: 20.99,
  ZAR: 16.81,
}

export const endToEndGuaranteePercentage = 20

export enum PricingTabType {
  TrademarkRegistration = 'trademark-registration',
  LegalServices = 'legal-services',
  BrandProtection = 'brand-protection',
  TrademarkRenewal = 'trademark-renewal',
  TrademarkOwnershipTransfer = 'trademark-ownership-transfer',
}

export const isPricingTab = (value: string): value is PricingTabType =>
  Object.values(PricingTabType).includes(value as PricingTabType)

export enum PriceRuleType {
  default = 'default',
  perTrademarkClass = 'per-trademark-class',
  // Same tiering arithmetic as per-trademark-class, but the unit is a trademark
  // rather than a Nice class (assignment/ownership-transfer pricing, where each
  // extra trademark can mean another form to file).
  perTrademark = 'per-trademark',
}
